// extracted by mini-css-extract-plugin
module.exports = {"atom__title-container":"styles_atom__title-container__fC5SD"};